export enum PriceSizeEnum {
    SMALL = 'small',
    BIG = 'big',
}
